/* ══════════════════════════════════════════════════════════════
   SHARED POINTER FEED

   Every mark on the page wants to know where the cursor is so its eye
   can follow it. One mousemove listener per mark would mean three
   listeners on the app shell alone, each doing its own layout read on
   every mouse event — so they share a single listener here instead.

   Reads are coalesced to one per animation frame. A mousemove can fire
   far more often than the screen refreshes, and there is no point
   computing a pupil position the browser will never paint. As a bonus
   this idles to zero cost when the tab is hidden, since rAF stops.
══════════════════════════════════════════════════════════════ */

const subscribers = new Set();

let lastX = 0;
let lastY = 0;
let frame = 0;

function flush() {
  frame = 0;
  subscribers.forEach(fn => fn(lastX, lastY));
}

function handleMove(e) {
  lastX = e.clientX;
  lastY = e.clientY;
  if (!frame) frame = requestAnimationFrame(flush);
}

export function onPointerMove(fn) {
  /* The listener only exists while something is actually watching. */
  if (subscribers.size === 0) {
    window.addEventListener('mousemove', handleMove, { passive: true });
  }
  subscribers.add(fn);

  return () => {
    subscribers.delete(fn);
    if (subscribers.size === 0) {
      window.removeEventListener('mousemove', handleMove);
      if (frame) { cancelAnimationFrame(frame); frame = 0; }
    }
  };
}
